import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';

import { Link } from 'core/routing';

import {
  Avatar,
  Skeleton,
  Heading,
  SvgIcon,
  Menu,
  Box,
  Tooltip,
} from 'components';

import { ArrowDown, ArrowRight } from 'icons';
import theme from 'styles/themes/wikifactory';

import { clientStore } from 'apps/client/app';

import WorkspaceSwitcherMenuItems from 'apps/components/Frame/WorkspaceSwitcherMenuItems';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const SwitcherWrapper = styled.span`
  display: inline-flex;
  align-items: flex-end;
  margin-left: 1rem;
`;

const Slug = styled(Link)`
  font-size: ${props => props.theme.font.size.xsmall};
  color: ${props => props.theme.color.wfGrey};
  &:hover {
    text-decoration: underline;
  }
`;

const WorkspaceSkeleton = () => (
  <Box my={8} sx={{ display: 'flex', alignItems: 'center' }}>
    <Skeleton variant='circle' width={56} height={56} />
    <Box ml={3} sx={{ display: 'flex', flexDirection: 'column' }}>
      <Skeleton
        variant='rectangle'
        width={150}
        height={25}
        sx={{ marginBottom: 8 }}
      />
      <Skeleton size='xxsmall' />
    </Box>
  </Box>
);

const WorkspaceIndicator = () => {
  const { activeSpace, workspaces } = clientStore;
  const [anchorEl, setAnchorEl] = React.useState(null);

  if (!activeSpace) return <WorkspaceSkeleton />;

  const { path } = activeSpace;
  const { avatar, title } = activeSpace.content;
  let avatarName = path.substring(1);
  let linkName = 'profile';
  let linkParams = {
    profile: path,
  };
  if (activeSpace.spaceType === 'INITIATIVE') {
    linkName = 'initiative';
    linkParams = {
      initiative: path,
    };
    avatarName = title;
  }

  const avatarSrc = avatar?.url;

  const handleClick = event => {
    setAnchorEl(event.target);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const shouldRenderWorkspaceSwitcher = workspaces && workspaces.length > 1;
  return (
    <Wrapper>
      <Link name={linkName} params={linkParams}>
        <Avatar size='large' src={avatarSrc} name={avatarName} />
      </Link>
      <Box
        ml={3}
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          onClick={handleClick}
          sx={{
            alignItems: 'center',
            cursor: 'pointer',
            display: 'flex',
          }}
          data-for='workspaceIndicator'
          data-tip='Switch Workspace'
          data-place='right'
        >
          <Heading size='medium'>{title}</Heading>
          {shouldRenderWorkspaceSwitcher && (
            <SvgIcon sx={{ marginTop: 4 }} icon={<ArrowDown />} size='medium' />
          )}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Slug name={linkName} params={linkParams}>
            Community Profile
          </Slug>
          &nbsp;
          <SvgIcon
            icon={<ArrowRight />}
            color={theme.color.wfGrey}
            size='xsmall'
          />
        </Box>
      </Box>
      <Menu
        placement='left-bottom'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <>
          <WorkspaceSwitcherMenuItems />
        </>
      </Menu>
      <Tooltip delayShow={200} place='right' id='workspaceIndicator' />
    </Wrapper>
  );
};

export default observer(WorkspaceIndicator);
